import { render, staticRenderFns } from "./DialogSpinner.vue?vue&type=template&id=2dda30ce&"
import script from "./DialogSpinner.vue?vue&type=script&lang=js&"
export * from "./DialogSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports